<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="ch00_fm02"></a><a id="page_ii"></a><img alt="image" src="images/f00ii-01.jpg"/></p>
<p class="noindent">This <em>carte de visite</em> showing an unidentified soldier is printed at actual size. The photographs in this collection have been enlarged.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?76decde5